import React, {useEffect, useState} from 'react';
import {Grid, Button, Paper, Box, CircularProgress} from '@material-ui/core';
import {Form, Formik} from 'formik';
import {i18n2} from 'features/i18n/i18n';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import PieChartPending from 'components/Graphics/Components/PieChart';
import ReasonGrid from './grids/ReasonGrid';
import getAllSectors from './requests/getAllSectors';
import {useUtilInformation} from 'components/hooks';
import getGraphicsReason from './requests/reason/getGraphicsReason';
import PopupReport from 'components/Popups/PopupReport';
import {addFilter} from './helpers/createFilters';
import {ReportTypes} from 'helpers/report';
import MultipleSelectAll from './form/multipleSelectAll';

const ReasonForm = (props) => {
  const {token} = useUtilInformation();
  const [isConsultReady, setIsConsultReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const paletteCustom = ['#D0EEA9', '#0C2A3B', '#003319', '#7030A0', '#00B0F0'];
  const [sectors, setSectors] = useState([]);
  const [dataGraphics, setDataGraphics] = useState();
  const [openReport, setOpenReport] = useState(false);
  const [filters, setFilters] = useState([]);
  const [reportType, setReportType] = useState(null);
  const [values, setValues] = useState(null);
  useEffect(() => {
    getAllSectors(token).then((data) => {
      if (data != null) {
        setSectors(data);
      }
    });
  }, [token]);

  const handleSubmit = (values, formikBag, isPopup) => {
    let temporalFilters = [];
    Object.entries(values).map(([k, v]) =>
      addFilter(k, v, temporalFilters, true),
    );
    setFilters(temporalFilters);
    if (isPopup) {
      setOpenReport(true);
      setValues(values);
    } else {
      setIsLoading(true);
      formikBag.setSubmitting(false);
      getGraphicsReason(token, values).then((data) => {
        if (data != null) {
          setDataGraphics(JSON.parse(data));
          setIsConsultReady(true);
          setIsLoading(false);
        }
      });
    }
  };

  const lookup = (x) => {
    switch (x) {
      case 'TIME':
        return 'Poco tiempo entre creación del curso y vigencia del SOP';
      case 'WORKTIME':
        return 'Falta de tiempo debido a volumen de trabajo';
      case 'VACATIONS':
        return 'Vacaciones';
      case 'HEALTH':
        return 'Licencia Médica';
      case 'OTHER':
        return 'Otros';
      case 'FORGETTING':
        return 'Olvidé ingresar al sistema';
      default:
        return 'Sin datos';
    }
  };

  return (
    <>
      <Paper style={{margin: 10, marginTop: 0, padding: 10}}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Formik
            initialValues={{
              sectors: [],
            }}
            enableReinitialize
            onSubmit={(values, formikBag) => {
              handleSubmit(values, formikBag);
            }}
          >
            {(formikProps) => {
              return (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={6}>
                      <MultipleSelectAll
                        name="sectors"
                        label={i18n2._('Sectores')}
                        changeValue={(val) =>
                          formikProps.setFieldValue('sectors', val)
                        }
                        options={sectors}
                        customOptionLabel={(x) => `${x.name}`}
                        customOptionSelected={(option, value) => {
                          return option.iD_Sector === value.iD_Sector;
                        }}
                      />
                    </Grid>
                    <Grid item md={8} xs={6}>
                      <Button
                        type="submit"
                        disabled={formikProps.isSubmitting}
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                      >
                        <Trans>Visualizar</Trans>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                        onClick={(e) =>
                          formikProps.validateForm().then((errors) => {
                            if (
                              Object.keys(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleSubmit(
                                formikProps.values,
                                formikProps.formikBag,
                                true,
                              );
                              setReportType(ReportTypes.PDF);
                            }
                          })
                        }
                      >
                        <Trans>Descargar PDF</Trans>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                        onClick={(e) =>
                          formikProps.validateForm().then((errors) => {
                            if (
                              Object.keys(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleSubmit(
                                formikProps.values,
                                formikProps.formikBag,
                                true,
                              );
                              setReportType(ReportTypes.Excel);
                            }
                          })
                        }
                      >
                        <Trans>Descargar excel</Trans>
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </MuiPickersUtilsProvider>
      </Paper>
      {isLoading ? (
        <Grid
          container
          alignContent="center"
          alignItems="center"
          justify="center"
        >
          <Box style={{margin: 50, padding: 50}}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : isConsultReady ? (
        <>
          <Paper style={{margin: 10, padding: 10}}>
            <PieChartPending
              // title="Pendientes"
              data={dataGraphics.pieChart}
              argumentField="value"
              valueField="data"
              color={paletteCustom}
              lookup={(x) => lookup(x)}
              // width={"50%"}
              // height={290}
            />
          </Paper>
          <Paper style={{margin: 10, padding: 10}}>
            <ReasonGrid dataSource={dataGraphics.grid} />
          </Paper>
        </>
      ) : null}
      <PopupReport
        open={openReport}
        setOpen={setOpenReport}
        filters={filters}
        pdfOnly={false}
        name="RazonTardanza"
        url="api/Report/ConsultaPorRazonGet"
        userFilters={values}
        type={reportType}
      />
    </>
  );
};

export default ReasonForm;
